import { z } from 'zod';
import type { TFunction } from 'i18next';

const TAG_MAX_LENGTH = 80;

// A factory, not a module-scope const: building the schema at import time would bake
// in whatever language was active then, and the messages could never follow a change.
export const buildFolderFormSchema = (t: TFunction<'projects'>) =>
  z.object({
    name: z
      .string()
      .trim()
      .min(1, t('manageProjectFolders.createFolderModal.folderNameIsRequired'))
      .max(255, t('manageProjectFolders.createFolderModal.nameIsTooLong')),
    briefId: z.string().nullable(),
    tags: z.array(
      z
        .string()
        .trim()
        .min(1)
        .max(
          TAG_MAX_LENGTH,
          t('manageProjectFolders.createFolderModal.tagMaxLength', { max: TAG_MAX_LENGTH }),
        ),
    ),
  });

export type FolderFormData = z.infer<ReturnType<typeof buildFolderFormSchema>>;
